export const REQUESt_INVENTORY_DATA = {
  ITEM_NAME: "itemName",
  SKU_CODE: "skuCode",
  CATEGORY: "category",
  TYPE: "type",
  QUANTITY: "quantity",
  EXPIRATION_DATE: "expirationDate",
  THRESHOLD_VALUE: "thresholdValue",
};

// Inventory category/type options for the "Select Category" filter — values
// must match the shared backend inventory `type` (mirrors the admin global
// inventory filter's INVENTORY_TYPE_OPTIONS).
export const INVENTORY_TYPE_OPTIONS = [
  { label: "All Types", value: "" },
  { label: "Medicine", value: "Medicine" },
  // Filter-only value — returns everything that isn't Medicine. Not a real
  // category, so it must never be offered when creating/editing an item.
  { label: "Not Medicine", value: "Not Medicine" },
  { label: "Medical Supplies", value: "Medical Supplies" },
  { label: "Linen", value: "Linen" },
  { label: "General Supplies", value: "General Supplies" },
  { label: "Medical Equipment", value: "Medical Equipment" },
];
